import { render, staticRenderFns } from "./ScriptsList.vue?vue&type=template&id=55749e20&scoped=true&"
import script from "./ScriptsList.vue?vue&type=script&lang=js&"
export * from "./ScriptsList.vue?vue&type=script&lang=js&"
import style0 from "./ScriptsList.vue?vue&type=style&index=0&id=55749e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55749e20",
  null
  
)

export default component.exports